/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19.07"
        height="12.75"
        viewBox="0 0 19.07 12.75"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#1570bc"
          d="M.1 6.17C.13 6.1 3.06 0 9.53 0s9.4 6.1 9.43 6.17l.1.22-.11.22c-.03.06-3.2 6.15-9.43 6.15S.14 6.66.11 6.6L0 6.38l.1-.22Zm1.02.2c.61 1.05 3.42 5.38 8.41 5.38s7.8-4.33 8.41-5.38C17.37 5.32 14.71 1 9.53 1S1.69 5.31 1.12 6.37Zm8.41-3.74a3.743 3.743 0 1 0 3.74 3.74 3.74 3.74 0 0 0-3.74-3.74Zm-2.54 4.8a2.744 2.744 0 0 0 5.28-1.05 2.737 2.737 0 0 0-4.68-1.93c-.78.79-1.02 1.97-.59 2.99Z"
          className="icon-fill"
          fillRule="evenodd"/>
        <path
          fill="none"
          stroke="#1570bc"
          d="m1.7.89 15.32 11.24"
          className="icon-stroke"
          strokeLinecap="round"/>
      </svg>
    );
  }
}

Icon.displayName = 'EyeWithSlashIcon';

export default Icon;
